<div class="content-label-container">
    <h1 [style.color]="titleColor" translate>navigation.knowledge</h1>
</div>

<div class="content-main-container">
    <div class="contents">
        <p translate>knowledge.tbd</p>
        <div class="image_area">
            <img src="../../../assets/img/etc/construction.svg" width="120px" height="120px">
        </div>
    </div>
</div>